import React, { useState } from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useParams } from "react-router-dom";

// import JS files
import useFetch from "../../context/useFetch";

// import others files

const ImageGallery = ({ image_list }) => {
  let windowWidth = window.screen.width;

  const { id } = useParams();

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: windowWidth <= 760 ? 2 : 4,
    count: 0,
    previous: null,
    next: null,
  });

  const [imgList, setImgList] = useState({ results: [] });
  const getImgList = useFetch({
    method: "get",
    pagination: paginationPageInfo,

    url: `News_Service/${id}/get_news_image`,
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setImgList(res);
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
  });

  const handleNextPage = () => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: paginationPageInfo.current + 1,
    });
    getImgList.reFetch();
  };

  const handlePrevPage = () => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: paginationPageInfo.current - 1,
    });
    getImgList.reFetch();
  };

  //! need_add_code
  return (
    <>
      <div className="mt-8 relative px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {paginationPageInfo.next !== null && (
            <div
              onClick={() => handleNextPage()}
              className="bg-mygrays-100 p-1 rounded-lg transition-all hover:scale-110  cursor-pointer absolute top-1/2 left-2 md:left-0 transform  -translate-y-1/2"
            >
              <ArrowBackIosNewIcon className="text-myblacks-100 transition-all hover:text-myblacks-400" />
            </div>
          )}
          {paginationPageInfo.previous !== null && (
            <div
              onClick={() => handlePrevPage()}
              className="bg-mygrays-100 p-1 rounded-lg transition-all hover:scale-110  cursor-pointer absolute top-1/2 right-2 md:right-0 transform  -translate-y-1/2"
            >
              <ArrowForwardIosIcon className="text-myblacks-100 transition-all hover:text-myblacks-400" />
            </div>
          )}

          {imgList.results.map((it, ind) => {
            return [<img src={it.image_file} className="rounded-lg" />];
          })}
        </div>
      </div>
    </>
  );
};

export default ImageGallery;
